"use client";

//import { SafeUser } from "@/types";

import { ThemedLogo } from "@/app-trust/src/components/nextTheme/ThemedLogo";
import useMutationAndResizeStyle from "@/hooks/useMutationAndResizeStyle";
import { cn } from "@/lib/utils";
import { SecurityStatus } from "@/packages/common/src/components/status/SecurityStatus";
import type { InfraSecurityChecks } from "@/prisma/prisma";
import getSecurityState from "@/src/queries/getSecurityState";
import { useQuery } from "@tanstack/react-query";
import { usePathname, useRouter } from "next/navigation";
import React, { useEffect, useRef, useState, type RefObject } from "react";

interface NavbarProps {
  currentUser?: any; //Previously SafeUser | Null
  initialSecurityState?: InfraSecurityChecks;
  className?: string;
  fixed?: boolean;
  showUserLoading?: boolean;
  subTitle?: string;
  statusDot?: boolean;
}

const NavbarTrust: React.FC<NavbarProps> = ({
  currentUser,
  className,
  initialSecurityState,
  subTitle,
  fixed,
  showUserLoading = true,
  statusDot = false,
}) => {
  const navRef = useRef<HTMLDivElement>(null);

  const [onEntriesPage, setOnEntriesPage] = React.useState(false);
  const router = useRouter();
  const pathname = usePathname();

  const [hasMounted, setHasMounted] = useState(false);

  /*const {
    data: securityState,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: ["securityState"],
    queryFn: async () => await getSecurityState(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    //refetchInterval: 1000, //1 second
    enabled: false,
  });*/
  let securityState: InfraSecurityChecks | undefined;
  const dateLastReviewed = securityState ? securityState?.end : initialSecurityState?.end;
  console.log("dateLastReviewed", dateLastReviewed, typeof dateLastReviewed, dateLastReviewed instanceof Date);

  //const regexForEntriesPage = /^\/entries\/[a-zA-Z0-9]{24}$/;

  useEffect(() => {
    setOnEntriesPage(pathname.includes("/entries/doc/"));
  }, [pathname]);

  function handleNavStyles(styles: any) {
    // Set the uiState.navbarBottomY to the height of the navbar
    // bottomY = top + height, remove the px from the value before calculating
    const navbarBottomY = Number.parseInt(styles.top) + Number.parseInt(styles.height);
    //setNavbarBottomY(navbarBottomY);
  }

  useEffect(() => {
    setHasMounted(true);
  }, []);

  // Track position-related styles
  const navStyles = useMutationAndResizeStyle(
    navRef as RefObject<HTMLElement | null>,
    ["position", "top"], // inline styles to watch
    ["top", "height", "bottom"], // computed styles to watch
    0, // no delay
    hasMounted, // enabled
    undefined,
    handleNavStyles,
    false // debug
  );

  // Check if the current pathname matches a specific condition
  //console.log("pathname", pathname);

  return (
    <div
      ref={navRef}
      className={cn(
        "relative left-0 right-0 top-0 z-30 flex h-navbar-height justify-between border-b border-border bg-background shadow-sm backdrop-blur-sm dark:text-white",
        {
          "fixed left-0 top-0 w-full": fixed,
          "top-banner-height": false,
        },
        className
      )}
    >
      <div className="min-h-4 relative flex gap-x-4 h-navbar-height justify-start px-2 items-center" onClick={() => router.push("/entries")}>
        <ThemedLogo width={164} height={164} />
        {subTitle && <div className="h-[65%] w-[1px] bg-border" />}
        {subTitle && <div className="pt-0.5 text-xl font-semibold text-background-dark text-nowrap">{subTitle}</div>}
      </div>
      <div className="mr-6 flex h-full w-full justify-end items-center">
        {statusDot && <SecurityStatus lastReviewed={dateLastReviewed} className="h-fit py-1.5" />}
      </div>
    </div>
  );
};

export default NavbarTrust;
